import React, { ReactNode } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import useBetaVersion from '@hooks/useBetaVersion/useBetaVersion';
import { BetaSurfaceKey } from '@hooks/useBetaVersion/betaSurfaces';

/** Link texts, already translated. Omit to keep the generic "Switch to new / legacy version". */
export interface VersionSwitchLabels {
  toNew: string;
  toLegacy: string;
}

interface LegacyVersionSwitchProps {
  surface: BetaSurfaceKey;
  children: (showLegacy: boolean) => ReactNode;
  /** Say what the link switches when a page shows more than one of them. */
  labels?: VersionSwitchLabels;
}

const LegacyVersionSwitch: React.FC<LegacyVersionSwitchProps> = ({ surface, children, labels }) => {
  const { tr } = useTranslationLgs();
  const { showLegacy, switchVisible, toggle } = useBetaVersion(surface);

  return (
    <>
      {children(showLegacy)}
      {switchVisible && (
        <div className={'flex justify-center m-2'}>
          <button
            type={'button'}
            onClick={() => toggle()}
            className={'text-xs text-content-tertiary underline hover:text-content-primary'}
          >
            {showLegacy
              ? (labels?.toNew ?? tr(`generic.switchToNewVersion`, `Switch to new version`))
              : (labels?.toLegacy ?? tr(`generic.switchToLegacyVersion`, `Switch to legacy version`))}
          </button>
        </div>
      )}
    </>
  );
};

export default LegacyVersionSwitch;
